import {
    buildConfigSlice,
    useConfigSlice,
    WidgetConfigSliceActionPayloadType,
} from 'widgets/store/configuration/configSlice';
import { WidgetType } from 'widgets/WidgetType';
import { selectPortfolioPlState } from 'widgets/portfolioPl/store/selectors';
import {
    initialPortfolioPlConfigState,
    PortfolioPlWidgetConfigState,
} from 'widgets/portfolioPl/store/config/PortfolioPlWidgetConfigState';

export const buildPortfolioPlConfigSlice = () =>
    buildConfigSlice<PortfolioPlWidgetConfigState>(
        WidgetType.PORTFOLIO_PL,
        selectPortfolioPlState,
        initialPortfolioPlConfigState
    );

export const usePortfolioPlConfigSlice = () =>
    useConfigSlice(buildPortfolioPlConfigSlice());

export type PortfolioPlConfigPayloadType =
    WidgetConfigSliceActionPayloadType<PortfolioPlWidgetConfigState>;
